/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Knowledge_TitleInputs */

const en_directory_knowledge_title = /** @type {(inputs: Directory_Knowledge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Knowledge base`)
};

const zh_directory_knowledge_title = /** @type {(inputs: Directory_Knowledge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`知识库`)
};

/**
* | output |
* | --- |
* | "Knowledge base" |
*
* @param {Directory_Knowledge_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_knowledge_title = /** @type {((inputs?: Directory_Knowledge_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Knowledge_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_knowledge_title(inputs)
	return zh_directory_knowledge_title(inputs)
});
export { directory_knowledge_title as "directory.knowledge.title" }